import React from "react";
import "../../App.css";
import PaymentTypeForm from "../PaymentTypeForm";

function PaymentTypePage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("payment-type")){
    return;}
  return (
    <div className="page-vehicle">
      <PaymentTypeForm sessionObject={sessionObject} />
    </div>
  );
}

export default PaymentTypePage;
